import React from "react"
import { FaTimes } from "react-icons/fa"

const CloseIcon = () => <FaTimes color="#fff" size="24px" />

export default CloseIcon
